import 'typescript/lib/lib.dom.d.ts'; // adds support for web globals as we need them here
import api from '@/api/axios';

export const downloadPracticeSessions = async (token: string) => {
  try {
    const { data } = await api.get(
      'api/patients/practicesessions/export/bundle',
      {
        headers: {
          Authorization: `JWT ${token}`,
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
      },
    );
    const dataBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: 'application/json',
    });
    const urlBlob = URL.createObjectURL(dataBlob);
    const aTagForDownload = window.document.createElement('a');
    // automated click for the a tag to download the link
    aTagForDownload.href = urlBlob;
    aTagForDownload.download = 'Übungsdauer.json';
    aTagForDownload.click();
    aTagForDownload.remove();
  } catch (error) {
    return Promise.reject(error);
  }
};
